export default class RequiresBasicAuthError extends Error {
  static CODE = 'requires-basic-auth'

  constructor(...args) {
    super(...args)
    this.code = RequiresBasicAuthError.CODE
  }
}
